import React, { useState, useEffect, useContext, useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

var SNOOZE_KEY = "onboarding_snoozed_session";

var STEPS = [
  { key: "connection", label: "Criar conexao WhatsApp",          path: "/connections" },
  { key: "queue",      label: "Criar pelo menos 1 fila",         path: "/queues" },
  { key: "user",       label: "Adicionar um usuario (atendente)",path: "/users" },
  { key: "connected",  label: "WhatsApp conectado (online)",      path: "/connections" },
  { key: "greeting",   label: "Configurar mensagem de saudacao", path: "/settings" },
  { key: "farewell",   label: "Configurar mensagem de despedida",path: "/settings" },
  { key: "message",    label: "Enviar a primeira mensagem",       path: "/tickets" },
];

var useStyles = makeStyles(function(theme) {
  return {
    fab: {
      position: "fixed",
      bottom: theme.spacing(3),
      left: theme.spacing(3),
      zIndex: 1300,
    },
    progressRoot: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    doneIcon:   { color: "#4caf50" },
    undoneIcon: { color: "#bdbdbd" },
    dialogTitle:{ fontWeight: 700 },
    stepDone:   { opacity: 0.7 },
    stepPending:{ fontWeight: 600 },
    arrowIcon:  { fontSize: "0.85rem" },
  };
});

function OnboardingChecklist() {
  var classes = useStyles();
  var history = useHistory();
  var auth = useContext(AuthContext);
  var user = auth.user;

  var isAdmin = user && (user.profile === "admin" || user.super === true);

  var statusState  = useState(null);
  var status       = statusState[0];
  var setStatus    = statusState[1];

  var openState    = useState(false);
  var open         = openState[0];
  var setOpen      = openState[1];

  var loadedState  = useState(false);
  var loaded       = loadedState[0];
  var setLoaded    = loadedState[1];

  var resetModeState = useState(false);
  var resetMode      = resetModeState[0];
  var setResetMode   = resetModeState[1];

  var prevAllDoneRef = useRef(null);

  function fetchStatus() {
    if (!isAdmin) return;
    api.get("/onboarding/status").then(function(res) {
      var data = res.data;
      if (data.allDone && prevAllDoneRef.current === false) {
        sessionStorage.setItem("onboarding_usage_active", "1");
        sessionStorage.setItem("onboarding_usage_step", "0");
        window.dispatchEvent(new CustomEvent("onboarding-usage-start"));
      }
      prevAllDoneRef.current = data.allDone;
      setStatus(data);
      if (!loaded) {
        setLoaded(true);
        var snoozed = sessionStorage.getItem(SNOOZE_KEY);
        if (!data.allDone && !snoozed) {
          setOpen(true);
        }
      }
    }).catch(function() {});
  }

  useEffect(function() {
    if (!isAdmin) return;
    fetchStatus();
    var interval = setInterval(fetchStatus, 60000);
    return function() { clearInterval(interval); };
  }, [isAdmin]);

  function handleSnooze() {
    sessionStorage.setItem(SNOOZE_KEY, "1");
    setResetMode(false);
    setOpen(false);
  }

  function handleOpen() {
    setResetMode(true);
    fetchStatus();
    setOpen(true);
  }

  function handleReset() {
    api.post("/onboarding/reset").then(function() {
      setResetMode(true);
      setOpen(true);
      fetchStatus();
    }).catch(function() {});
  }

  function handleStepClick(key, path) {
    if (key) sessionStorage.setItem("onboarding_hint", key);
    setOpen(false);
    setResetMode(false);
    sessionStorage.removeItem(SNOOZE_KEY);
    history.push(path);
  }

  if (!isAdmin || !loaded) return null;
  if (!resetMode && status && status.allDone) return null;

  // stepsArr: array from API with { key, done, path, label }
  // stepsMap: { key -> { done, path } } for fast lookup
  var stepsArr = (status && status.steps) ? status.steps : [];
  var stepsMap = stepsArr.reduce(function(acc, s) {
    acc[s.key] = s;
    return acc;
  }, {});

  var doneCount = STEPS.filter(function(s) {
    return stepsMap[s.key] && stepsMap[s.key].done;
  }).length;
  var progress = Math.round((doneCount / STEPS.length) * 100);

  return React.createElement(
    React.Fragment,
    null,
    !open && React.createElement(
      Tooltip,
      { title: "Checklist de configuracao", placement: "right" },
      React.createElement(
        Fab,
        { color: "primary", className: classes.fab, onClick: handleOpen, size: "medium" },
        React.createElement(AssignmentIcon, null)
      )
    ),
    React.createElement(
      Dialog,
      { open: open, onClose: handleSnooze, maxWidth: "sm", fullWidth: true },
      React.createElement(
        DialogTitle,
        null,
        React.createElement(Typography, { variant: "h6", className: classes.dialogTitle }, "Configuracao inicial"),
        React.createElement(LinearProgress, {
          variant: "determinate",
          value: progress,
          className: classes.progressRoot,
        }),
        React.createElement(Typography, { variant: "caption" },
          doneCount + "/" + STEPS.length + " concluidos"
        )
      ),
      React.createElement(
        DialogContent,
        null,
        React.createElement(
          List,
          { dense: true },
          STEPS.map(function(step) {
            var apiStep = stepsMap[step.key] || {};
            var done = !!apiStep.done;
            var path = apiStep.path || step.path;
            return React.createElement(
              ListItem,
              {
                key: step.key,
                button: true,
                onClick: function() { handleStepClick(step.key, path); },
                className: done ? classes.stepDone : classes.stepPending,
              },
              React.createElement(
                ListItemIcon,
                null,
                done
                  ? React.createElement(CheckCircleIcon, { className: classes.doneIcon })
                  : React.createElement(RadioButtonUncheckedIcon, { className: classes.undoneIcon })
              ),
              React.createElement(ListItemText, { primary: step.label }),
              React.createElement(
                ListItemSecondaryAction,
                null,
                React.createElement(
                  IconButton,
                  { edge: "end", size: "small", onClick: function() { handleStepClick(step.key, path); } },
                  React.createElement(ArrowForwardIosIcon, { className: classes.arrowIcon })
                )
              )
            );
          })
        )
      ),
      React.createElement(
        DialogActions,
        null,
        React.createElement(
          Button,
          {
            onClick: handleReset,
            color: "default",
            size: "small",
            style: { marginRight: "auto", opacity: 0.5, fontSize: "0.7rem" },
          },
          "Reiniciar"
        ),
        React.createElement(
          Button,
          { onClick: handleSnooze, color: "default" },
          "Fechar"
        )
      )
    )
  );
}

export default OnboardingChecklist;
